// State module for snackbar information

function setErrorMessage(errorNb, errorList) {
  if (errorList.every((error) => error.code && error.code.startsWith('5'))) {
    if (errorNb === 1) {
      return "Le serveur a rencontré une erreur, veuillez réessayer. Si le problème persiste, contactez l'équipe de développement.";
    }
    return "Le serveur a rencontré des erreurs, veuillez réessayer. Si le problème persiste, contactez l'équipe de développement.";
  }
  if (errorNb === 1) {
    return 'Une erreur est survenue lors de la récupération des données.';
  }
  return `Des erreurs sont survenues lors de la récupération des données.`;
}

function setErrorMore(errorList) {
  return errorList.map(
    (err) =>
      (err.response &&
        (err.response.data ? err.response.data.errors : err.response.errors)) ||
      err
  );
}

const snackbar = {
  namespaced: true,
  state: {
    message: '',
    more: null,
    isOpen: false,
    color: null,
    timeout: null,
    closeable: false,
    errors: { count: 0, list: [] },
  },
  getters: {
    message: (state) => state.message,
    more: (state) => state.more,
    isOpen: (state) => state.isOpen,
    color: (state) => state.color,
    timeout: (state) => state.timeout,
    closeable: (state) => state.closeable,
    errorsCount: (state) => state.errors.count,
    errorsList: (state) => state.errors.list,
    errorsReducedList: (state) => state.errors.list.map((item) => item.error),
  },
  mutations: {
    SET_SNACKBAR_OPEN: (
      state,
      { message, more, color, timeout, closeable }
    ) => {
      state.isOpen = true;
      state.more = more;
      state.message = message;
      state.color = color;
      state.timeout = timeout;
      state.closeable = closeable;
    },
    SET_SNACKBAR_CLOSE: (state) => {
      state.message = '';
      state.more = null;
      state.isOpen = false;
      state.color = null;
      state.timeout = null;
      state.closeable = false;
    },
    ADD_ERROR: (state, error) => {
      state.errors = {
        count: state.errors.count + 1,
        list: state.errors.list.concat(error),
      };
    },
    CLEAR_ERROR: (state) => {
      state.errors = { count: 0, list: [] };
    },
  },
  actions: {
    setSnackbarOpen({ commit }, payload) {
      commit('SET_SNACKBAR_OPEN', payload);
    },
    setSnackbarClose({ commit }) {
      commit('SET_SNACKBAR_CLOSE');
      commit('CLEAR_ERROR');
    },
    setError({ commit, getters }, payload) {
      // eslint-disable-next-line no-underscore-dangle
      if (!payload.error.__CANCEL__ ?? false) {
        commit('ADD_ERROR', payload);
        commit('SET_SNACKBAR_OPEN', {
          message: setErrorMessage(
            getters.errorsCount,
            getters.errorsReducedList
          ),
          more: setErrorMore(getters.errorsList),
          color: 'error',
          closeable: true,
        });
      }
    },
    clearErrors: ({ commit }) => {
      commit('CLEAR_ERROR');
    },
  },
};

export default snackbar;
